// extracted by mini-css-extract-plugin
export var button = "bL_mf";
export var button__darkBlue = "bL_mk";
export var button__edgesGrey = "bL_ml";
export var button__edgesRed = "bL_mh";
export var button__loader = "bL_mm";
export var button__red = "bL_mg";
export var button__transparent = "bL_mj";
export var loadingSpinner = "bL_mn";